import styled from 'styled-components'

import UnstyledButton from 'components/Editor/EditorElements/courseKit/UnstyledButton'
import { outlineStyles } from 'components/Editor/styled/Outline'

import PointStyled from './PointStyled'

const PointButton = styled(UnstyledButton)`
  &:focus-visible {
    ${PointStyled} {
      ${outlineStyles}
    }
  }
`

export default PointButton
